module.exports = __webpack_public_path__ + "img/ic-header-receipts.a987e6dd.svg";